import { ConfigProvider } from "antd";
import { DatePicker as DatePickerJalali } from "antd";
import fa_IR from "antd/lib/locale/fa_IR";
import { JalaliLocaleListener } from "antd-jalali";
import dayjs, { Dayjs } from "dayjs";

interface DateJalaliProps {
  disabled: boolean;
  initialValue: string | null;
  width?: number;
  className?: string;
  inputReadOnly?: boolean;
  disabledDate: (everyDay: Dayjs) => boolean;
  onChange: (objectEvent: Dayjs | null) => void;
}

const CalendarJalali = ({
  disabled,
  initialValue,
  width,
  className,
  inputReadOnly,
  disabledDate,
  onChange,
}: DateJalaliProps) => {
  // اگر از پلاگین Jalali استفاده می‌کنید، آن را درست import کنید
  // dayjs.calendar("jalali");

  function dateConverter(): Dayjs | null {
    const date =
      initialValue && initialValue !== "undefined" ? dayjs(initialValue) : null;
    return date;
  }

  return (
    <ConfigProvider locale={fa_IR} direction="rtl">
      <JalaliLocaleListener />
      <DatePickerJalali
        disabled={disabled}
        className={
          className ? className : `inner-box-hover py-1 w-[${width ?? 240}px]`
        }
        defaultValue={dateConverter()}
        disabledDate={disabledDate}
        inputReadOnly={inputReadOnly}
        onChange={(value) => {
          if (Array.isArray(value)) {
            onChange(value[0] ?? null);
          } else {
            onChange(value ?? null);
          }
        }}
      />
    </ConfigProvider>
  );
};

export default CalendarJalali;
